/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { propEq } from 'ramda';
import { useEffect, useState } from 'react';

import FORM_OPTIONS from './FormOptions';

// options is array of string fields => ['email', 'first_name', ...etc]
const MemberForm = ({ options = [], handleChange }) => {
	const [available_fields, setAvailableFields] = useState([...FORM_OPTIONS]);
	// const [linked_members, setLinkedMembers] = useState([]);

	const handleCheck = id => event => {
		const newFields = available_fields.map(field => {
			if (field.id === id) {
				field.checked = event.target.checked;
			}
			return field;
		});
		handleChange(newFields);
	};

	useEffect(() => {
		if (options.length > 0) {
			setAvailableFields(prev =>
				prev.map(field => {
					if (options.indexOf(field.postValue) > -1) {
						return {
							...field,
							checked: true
						};
					}
					return field;
				})
			);
		}
	}, [options]);

	const visible_fields = available_fields.filter(propEq(true, 'checked'));

	return (
		<Grid container spacing={2} sx={{ display: 'flex', padding: '16px' }}>
			<Grid item sm={6} xs={12}>
				<Paper sx={{ padding: '16px' }}>
					<Typography component={'span'} color="primary.main" variant="h6">
						CREATE MEMBERSHIP SIGN UP FORM
					</Typography>
					<List>
						{available_fields.map(field => {
							return (
								<Box key={field.id}>
									<ListItem>
										<ListItemText primary={field.label}></ListItemText>
										<ListItemSecondaryAction>
											<Checkbox
												edge="end"
												disabled={field.required}
												onChange={handleCheck(field.id)}
												checked={field.checked}
											/>
										</ListItemSecondaryAction>
									</ListItem>
									<Divider component="li" />
								</Box>
							);
						})}
					</List>
				</Paper>
			</Grid>
			<Grid item sm={6} xs={12} sx={{ display: 'flex' }}>
				<Paper
					sx={{ padding: '16px', flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' }}
				>
					<Grid container spacing={2} sx={{ width: '100%' }}>
						{visible_fields.map(field => field.component)}
					</Grid>
					{/* <Grid container spacing={2} style={{ width: '100%' }}>
						{linked_members.map(g => g.map(field => field.component))}
					</Grid> */}
				</Paper>
			</Grid>
		</Grid>
	);
};

export default MemberForm;
